"use client";

import { useState } from "react";
import { type Story_Fields } from "~/__generated__/graphql";
import CustomImage from "~/components/CustomImage";
import VideoPopup from "~/components/VideoPopup";

export default function Story({
  title,
  description,
  label,
  type,
  video,
  image,
}: Story_Fields) {
  const [videoPopupOpen, setVideoPopupOpen] = useState(false);

  return (
    <>
      <VideoPopup
        isOpen={videoPopupOpen}
        ignoreCookies
        callback={() => setVideoPopupOpen(false)}
        videoSourceUrl={video?.url ?? ""}
        isPrismicVideo={false}
        title="Video"
      />
      <div
        className="relative h-full min-h-80 hover:cursor-pointer"
        onClick={() => setVideoPopupOpen(true)}
      >
        {type?.[0] === "Video" && video?.preview?.node.mediaItemUrl && (
          <>
            <video
              disablePictureInPicture
              disableRemotePlayback
              playsInline
              controls={false}
              loop
              muted
              src={video?.preview?.node.mediaItemUrl}
              // eslint-disable-next-line
              onMouseOver={(event) => (event.target as any).play()}
              // eslint-disable-next-line
              onMouseOut={(event) => (event.target as any).pause()}
              className="hidden aspect-video h-full w-full object-cover xl:block"
            ></video>
            <video
              disablePictureInPicture
              disableRemotePlayback
              playsInline
              controls={false}
              loop
              muted
              autoPlay
              src={video?.preview?.node.mediaItemUrl}
              className="aspect-video h-full w-full object-cover xl:hidden"
            ></video>
          </>
        )}
        {type?.[0] === "Image" && image && (
          <CustomImage
            data={image}
            className="aspect-video h-full w-full"
            sizes="(min-width: 1280px) calc(50vw - 197px), (min-width: 1040px) calc(50vw - 101px), (min-width: 780px) calc(50vw - 29px), calc(100vw - 48px)"
          />
        )}
        <div className="absolute bottom-0 flex h-1/2 w-full flex-col justify-end bg-gradient-to-t from-true-black to-transparent px-6 pb-6">
          <div className="mb-[0.875rem] w-fit rounded-[1px] bg-blue px-[0.875rem] py-[0.625rem] text-sm text-white">
            {label}
          </div>
          <div className="mb-[0.3125rem] text-2xl text-white">{title}</div>
          <div className="line-clamp-2 text-white">{description}</div>
        </div>
      </div>
    </>
  );
}
